import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useDeviceDetectorContext } from '../../../device-detector'
import { useIsfreeGiftPromotionsExperimentEnabledAndNotDefault } from '../../../experiments/components/ExperimentFreeGiftPromotion/useGetFreeGiftPromotionsExperiment'
import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../productPageContext'

import { ProductDescriptionCautionsDisclaimer } from './ProductDescriptionCautions'
import { ProductDescriptionManufacturerDetails } from './ProductDescriptionManufacturerDetails'
import { ProductDescriptionOldLayout } from './ProductDescriptionOldLayout'
import { ProductDescriptionPromotions } from './ProductDescriptionPromotions'
import { ProductDescriptionResponsiblePersonEu } from './ProductDescriptionResponsiblePersonEu'
import { ProductDescriptionTopDescriptions } from './ProductDescriptionTopDescriptions'
import { ProductDescriptionWithMultipleAccordions } from './ProductDescriptionWithMultipleAcordions'
import { useProductDescriptionSections } from './useProductDescriptionSections'

export const ProductDescription: FC<{ className: string }> = ({
  className,
}) => {
  const { product } = useProductPageContext()
  const { hasIfapSections } = useProductDescriptionSections()

  const hasSplitAttributes = product.has_split_attributes
  const showSplitAttributesDescription =
    productAccessorIsPrescriptionProduct(product) && hasSplitAttributes
  const { isMobile } = useDeviceDetectorContext()
  const isfreeGiftPromotionsExperimentEnabledAndNotDefault =
    useIsfreeGiftPromotionsExperimentEnabledAndNotDefault(isMobile)

  return (
    <div className={className} data-qa-id="product-description">
      <div className="scroll-mt-4" id="pflichtangabe" />
      <h2 className="mb-5 text-2xl font-medium">
        <FormattedMessage id="productAdditonalInfos.headline" />
      </h2>
      <ProductDescriptionCautionsDisclaimer />
      <ProductDescriptionTopDescriptions product={product} />
      {!isfreeGiftPromotionsExperimentEnabledAndNotDefault && (
        <ProductDescriptionPromotions />
      )}
      {showSplitAttributesDescription || hasIfapSections ? (
        <ProductDescriptionWithMultipleAccordions />
      ) : null}
      {!showSplitAttributesDescription && !hasIfapSections && (
        <ProductDescriptionOldLayout />
      )}
      {product.manufacturer_details ? (
        <ProductDescriptionManufacturerDetails
          manufacturerDetails={product.manufacturer_details}
        />
      ) : null}
      {product.responsible_person_eu ? (
        <ProductDescriptionResponsiblePersonEu
          responsiblePersonEU={product.responsible_person_eu}
        />
      ) : null}
    </div>
  )
}
